const makeHistory = (messageArray, number) => {
  let chat_hist = [];
  let arr_length = messageArray.length - 1;
  if (arr_length === 0) {
    chat_hist = [
      {
        question: "",
        answer: "",
      },
    ];
  } else {
    for (let i = 0; i < number; i++) {
      if (arr_length === 0) break;
      chat_hist.push({
        question: messageArray[arr_length - 1]?.message,
        answer: messageArray[arr_length]?.message,
      });
      arr_length -= 2;
    }
  }
  return chat_hist;
};

export default makeHistory;
